module.exports = __webpack_public_path__ + "assets/img/YuanhangEdition.88dbbd24.png";